import React, {
  useState,
  useEffect,
  Fragment,
  useCallback,
  useRef,
} from "react";
import { toast } from "react-toastify";
import Draggable from "react-draggable";
import SelectComponent from "../common-components/select";
import { WebAudioPlayer, AudioModal, BetTypeModal } from "../common-components";
import InputPrePostFixComponent from "../common-components/inputPrePostFix";
import CasinoCrashGame from "./crash-casino";
import { socketConn } from "../../helper/socket-io";
import HistoryModal from "./CrashEngine/history-modal";
import GameInfoModal from "./CrashEngine/game-info-modal";
import MaxBetModal from "./CrashEngine/max-bet-modal";
import LiveHistory from "./CrashEngine/live-data";
import AutobetControls from "./CrashEngine/autobet-controls";
import LiveStats from "./CrashEngine/live-stats";

import Doller from "../../assets/images/doller.png";
import Setting from "../../assets/images/setting-2.png";
import Startup from "../../assets/images/status-up.png";
import Volume from "../../assets/images/volume-high.png";
import Users from "../../assets/images/profile-2user.png";
import Maxbet from "../../assets/images/Group (1).png";
import Info from "../../assets/images/info-circle.png";
import LiveChat from "./CrashEngine/live-chat";
import BackgroundSound from "../../assets/Walen - Nostalgia Gaming (freetouse.com).mp3";
import WinSound from "../../assets/spin-complete-295086.mp3";
import CrashSound from "../../assets/crash-1-97700.mp3";

export const GameScreen = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [rejoin, setRejoin] = useState("disconnected");
  const [activeTab, setActiveTab] = useState(0); //getCookies("activeTab")
  const [activeSubTab, setActiveSubTab] = useState(0);
  const [options, setOptions] = useState([
    { label: "Even", value: "even" },
    { label: "Odd", value: "odd" },
  ]);
  const [newRoundStarted, setNewRoundStarted] = useState(false);
  const [makeItJoinAgain, setMakeItJoinAgain] = useState(false);
  const [start, setStart] = useState(false);
  const [clear, setClear] = useState(false);
  const [socket, setSocket] = useState(null);
  const [orDisable, setOrDisable] = useState({crash: true, cash: false})
  const [gameConfig, setGameConfig] = useState(null);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [tableJoined, setTableJoined] = useState(null);
  const [gameTimer, setGameTimer] = useState(null);
  const [autoBetCompleted, setAutoBetCompleted] = useState(true);
  const [manualBetCompleted, setManualBetCompleted] = useState(true);
  const [allBetCompleted, setAllBetCompleted] = useState(true);
  const [audioAllowModal, setAudioAllowModal] = useState({
    open: true,
    allow: false,
  });
  const [betTypeModal, setBetTypeModal] = useState({
    open: false,
    allow: false,
  });
  const [alreadyJoined, setAlreadyJoined] = useState(false);
  const [timerStart, setTimerStart] = useState(false);

  const [payoutMultiplier, setPayoutMultipier] = useState(0.0);
  const [crashFlight, setCrashFlight] = useState(null);
  const [roundId, setRoundId] = useState(null);
  let roundidlatest = "";
  const maxReconnectAttempts = 5;
  const [reconnectAttempts, setReconnectAttempts] = useState(0);

  const [betPlaced, setBetPlaced] = useState(null);
  const [cashedOut, setCashedOut] = useState(null);
  const [lock, setLock] = useState(false);
  const [cashedOutHistory, setCashedOutHistory] = useState([]);
  const [betHistory, setBetHistory] = useState([]);
  const [betCashoutDisable, setBetCashoutDisable] = useState(true);
  const [gameInfoModal, setGameInfoModal] = useState(false);
  const [remainingBet, setRemainingBet] = useState(0);
  const [maxBetModal, setMaxBetModal] = useState({
    open: false,
    maxBet: '',
    enable: false,
  });

  const [betStopped, setBetStopped] = useState(false);
  const [messages, setMessages] = useState([]);
  const [openChat, setOpenChat] = useState(false);

  const [volume, setVolume] = useState(50);
  const [wallet, setWallet] = useState(0);
  const [liveCashout, setLiveCashout] = useState({ show: false, data: [] });
  const [liveBetPlace, setLiveBetPlace] = useState([]);
  const [settingStartupPopover, setSettingStartupPopover] = useState({
    setting: false,
    startup: false,
  });

  const [form, setForm] = useState({
    betAmount: '',
    crashType: "",
    cashOutAt: '',
  });
  const [autoForm, setAutoForm] = useState({
    betAmount: '',
    cashOutAt: '',
    crashType: "",
    numOfBet: '',
    onWin: '',
    onLoss: '',
    stopProfit: '',
    stopLoss: '',
    profitWin: '',
  });

  const tabs = ["Manual", "Auto"];
  const subTabs = ["Controls", "Leaderboard"];

  const connectSocket = useCallback(() => {
   


    if (!socketConn.connected) {
      socketConn.connect();
    }

    socketConn.off("reconnect");
    socketConn.off("connect");
    socketConn.off("connected");
    socketConn.off("connect_error");
    socketConn.off("disconnect");

    socketConn.on("reconnect", (attempt) => {
      console.log("Reconnected after", attempt, "attempts");
    });

    socketConn.on("connect", () => {
      console.log("connect");
      setAudioAllowModal({ open: true, allow: false });
      // if (document.visibilityState === "visible") {
      toast.success("Socket connected");
      setIsOnline(true);

      // }

      setRejoin("connected");
    });
    // socketConn.on("connected", () => {
    
    //   // setAudioAllowModal({ open: true, allow: false });

    //   setRejoin("connected");
    // });

    socketConn.on("connect_error", (error) => {
      console.log("connect_error");
      toast.error("Socket connection error");

      // attemptReconnect();
    });

    socketConn.on("disconnect", () => {
      console.log("Disconnected from server");
      setRejoin("disconnected");
      // if (document.visibilityState === "visible") {
      toast.error("Socket connection error");
      // }

      // attemptReconnect();
    });

    setSocket(socketConn);

    return () => {
      // socketConn.disconnect();
    };
  }, []);
  useEffect(() => {
    const cleanup = connectSocket();

    return () => {
      console.log("cleanup");
      cleanup();
      setSocket(null);
    };
  }, [connectSocket]);

  const attemptReconnect = () => {
    // if (reconnectAttempts < maxReconnectAttempts) {
    //   const delay = Math.min(5000, 1000 * 2 ** reconnectAttempts); // Exponential backoff
    //   console.log(`Attempting to reconnect in ${delay / 1000} seconds...`, reconnectAttempts);
    //     setReconnectAttempts(reconnectAttempts+1);
    //     connectSocket()
    // } else {
    //   console.error("Max reconnection attempts reached");
    //   toast.error("Unable to reconnect to the server.");
    // }
  };

  window.addEventListener("pagehide", () => {
    // socket.close();
  });

  useEffect(() => {
    
    if (gameConfig && isOnline && !alreadyJoined) {
      // setTimeout(() => {
        console.log("join")
        setAlreadyJoined(true)
        if (activeTab == 1) {
          
          socket.emit(
            "joinTable",
            {
              betType: "autoBet",
              roundId: roundId,
              betAmount: autoForm.betAmount,
              crashType: autoForm?.crashType,
              numOfBet: autoForm.numOfBet,
              stopProfit: autoForm.stopProfit,
              stopLoss: autoForm.stopLoss,
              admin_id: gameConfig?.admin_id,
              socketId: socket._id,
              reconnected: true,
              engine_id: gameConfig?.engine_id,
            },
            (response) => {}
          );
        } else if (activeTab == 0) {
          socket.emit(
            "joinTable",
            {
              betType: "manualBet",
              roundId: roundId,
              betAmount: form.betAmount,
              crashType: form?.crashType,
              admin_id: gameConfig?.admin_id,
              socketId: socket._id,
              reconnected: true,
              engine_id: gameConfig?.engine_id,
            },
            (response) => {}
          );
        }
      // }, 1000);
    }
  }, [gameConfig, isOnline]);

 

  useEffect(() => {
    const handleOnline = () => {
      console.log("online");

      setIsOnline(true);
      socketConn.connect();
    };
    const handleOffline = () => {
      console.log("offline");
      setIsOnline(false);
      socketConn.disconnect();
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    return () => {
      // socket?.off("config");
      // socket?.off("roundStart");
      // socket?.off("tableJoined");
      // socket?.off("crashHistory");
      // socket?.off("gameTimer");
      // socket?.off("betHistory");
      // socket?.off("bets");
      // socket?.off("betPlaced");
      // socket?.off("balance");
      // socket?.off("roundsBet");
      // socket?.off("roundsCashedout");
      // socket?.off("payoutMultiplyer");
      // socket?.off("crashFlight");
      // socket?.off("cashedout");
    };
  }, []); 

  useEffect(() => {
    
    console.log(290, audioAllowModal, socket?.connected, gameConfig, socketConn.listeners("config").length)

    if (socket?.connected &&  gameConfig == null) {
      if (socketConn.listeners("config").length === 0) {
        console.log(296, audioAllowModal, socket?.connected, gameConfig, socketConn.listeners("config").length)

       
        socket.emit("config", null, (response) => {
          setAllBetCompleted(true);
          console.log("config Acknowledgment from server:", response);
          setGameConfig(response);
          setMaxBetModal((prev) => ({ ...prev, maxBet: response.max_betamount }));
        });
      }
         
    }
  }, [audioAllowModal, isOnline]); // isOnline, socketConn, socket

  useEffect(() => {
    if (manualBetCompleted) {
      setAutoBetCompleted(true);
    }
  }, [manualBetCompleted]);

  useEffect(() => {
    // console.log(311)
    if (roundId && makeItJoinAgain && !alreadyJoined) {
      if (makeItJoinAgain) {

        setTimeout(() => {
          console.log("join 313 again")
        if (activeTab == 1) {
         
          socket.emit(
            "joinTable",
            {
              betType: "autoBet",
              roundId: roundId,
              betAmount: autoForm.betAmount,
              crashType: autoForm?.crashType,
              numOfBet: autoForm.numOfBet,
              stopProfit: autoForm.stopProfit,
              stopLoss: autoForm.stopLoss,
              admin_id: gameConfig?.admin_id,
              socketId: socket._id,
              reconnected: true,
              engine_id: gameConfig?.engine_id,
            },
            (response) => {}
          );
        } else if (activeTab == 0) {
          socket.emit(
            "joinTable",
            {
              betType: "manualBet",
              roundId: roundId,
              betAmount: form.betAmount,
              crashType: form?.crashType,
              admin_id: gameConfig?.admin_id,
              socketId: socket._id,
              reconnected: true,
              engine_id: gameConfig?.engine_id,
            },
            (response) => {}
          );
        }
        }, 1500);
        
      }
    }
  }, [roundId, makeItJoinAgain, alreadyJoined]);

  useEffect(() => {
    if (gameConfig && socket) {
      socket?.off("tableJoined");

      // && !audioAllowModal.open
      socket.on("groupChatMessage", (response) => {
        console.log("groupChatMessage Acknowledgment from server:", response);
        setMessages([response]);
      });

      socket.on("userJoined", (response) => {
        console.log("userJoined Acknowledgment from server:", response);
        // setMessages((prev) => ([...prev, response.message]))
      });
      
      
      socket.on("roundStart", (response) => {
        console.log("roundStart", response)
        setNewRoundStarted(true);
        setRoundId(response?.roundId);

        setClear(false);
        roundidlatest = response.roundId;
        setLock(false);
        setManualBetCompleted(true);
        setCrashFlight(null);
        // setClear(true)
        setPayoutMultipier(1);
        // console.log(345, {allBetCompleted})
        

        if (response?.startSoon) {
          console.log(370, )
          toast.warn(response.startSoon);
        }
        // setTimerStart(true)
        setTimerStart(true);
        setTimeout(() => {
          setTimerStart(false);
        }, 1000);

        if (activeTab == 0) {
          setForm((prev) => ({ ...prev, crashType: "" }));
        }







        if (activeTab == 0) {
          setBetPlaced(null);

          setForm((prev) => ({ ...prev, crashType: "" }));
        }

        roundidlatest = response.roundId;
        if (document.visibilityState === "visible") {
          toast.success(response?.message);
        }

        setCashedOut(null);
        // setClear(true) 
        // setTimeout(() => {
        //   setClear(false) 
        // }, 1000);
        // setPayoutMultipier(0);
       

        socket.emit("betHistory", (response) => {
          console.log("betHistory Acknowledgment from server:", response);
        });
      });

      if (socketConn.listeners("tableJoined").length === 0) {
        socket.on("tableJoined", (response) => {
        
          console.log("tableJoined", response)
          if (response?.joinAgain) {
            setMakeItJoinAgain(true);
            setRoundId(null)
            setAlreadyJoined(false)
          } else {
            // setRoundId(response.data.roundId); // may be this
            setMakeItJoinAgain(false);
          }
  
          setTableJoined(response.data);
          setWallet(response.data.balance);
  
          setCashedOut(null);
  
          if (audioAllowModal.allow) {
            if (gameConfig.background_sound_url) {
              playSound(gameConfig.background_sound_url, true);
            } else {
              playSound(BackgroundSound, true);
            }
          }
  
         
          roundidlatest = response.data.roundId;
        });
      }

     
      socket.on("crashHistory", (response) => {
        console.log("crashHistory Acknowledgment from server:", response);
        setCashedOutHistory(response?.data);

        // toast(response?.message);
      });
    }
  }, [gameConfig, socket]); // betTypeModal

  useEffect(() => {
    if (!audioAllowModal.open) {
      setBetTypeModal({ open: false, allow: false });
    }
    if (audioAllowModal?.allow && gameConfig) {
      if (gameConfig.background_sound_url) {
        playSound(gameConfig.background_sound_url, true);
      } else {
        playSound(BackgroundSound, true);
      }
    }
  }, [audioAllowModal]);

  useEffect(() => {
    if (tableJoined) {
      socket.on("bets", (response) => {
        // console.log("bets Acknowledgment from server:", response);
        setBetHistory(response.data);
      });

      // socket.on("roundStart", (response) => {
      //   setNewRoundStarted(true);
      //   console.log(
      //     "1166 roundStart Acknowledgment from server:",
      //     makeItJoinAgain
      //   );

      //   setLock(false);

      //   if (activeTab == 0) {
      //     setBetPlaced(null);

      //     setForm((prev) => ({ ...prev, crashType: "" }));
      //   }
      //   setManualBetCompleted(true);
      //   console.log(417, { allBetCompleted });
      //   if (allBetCompleted) {
      //     // setAutoBetCompleted(true)
      //   }
      //   if (response?.startSoon) {
          
      //     // toast.warn(response.startSoon);
      //   }

      //   setCrashFlight(null);
      //   setRoundId(response?.roundId);
      //   roundidlatest = response.roundId;
      //   if (document.visibilityState === "visible") {
      //     toast.success(response?.message);
      //   }

      //   setCashedOut(null);
      //   setPayoutMultipier(0.0);
      //   setLock(false);
      //   setTimerStart(true);
      //   setTimeout(() => {
      //     setTimerStart(false);
      //   }, 1000);

      //   socket.emit("betHistory", (response) => {
      //     console.log("betHistory Acknowledgment from server:", response);
      //   });
      // });

      if (!betStopped) {
        socket.on("gameTimer", (response) => {
          setMakeItJoinAgain(false);
          // console.log("gameTimer Acknowledgment from server:", response.roundId);
          setGameTimer(response);
          // setClear(false)
          setRoundId(response?.roundId);
          roundidlatest = response.roundId;
          // console.log("00000", lock)
          if (response.time == gameConfig.betLock) {
            setLock(true);

            setAutoBetCompleted(false);
            setManualBetCompleted(false);
          }
        });
      } else {
        // socket?.off("gameTimer");
        // socket?.off("payoutMultiplyer");
        // socket?.off("crashFlight");
      }
    }
  }, [tableJoined, betStopped]);

  useEffect(() => {
    if (betPlaced) {
      if (betPlaced?.crashType == "") {
        if (betPlaced?.minCashout > payoutMultiplier) {
          setBetCashoutDisable(true);
        } else {
          setBetCashoutDisable(false);
        }
      } else {
        setBetCashoutDisable(true);
      }
    }
  }, [betPlaced, payoutMultiplier]);

  useEffect(() => {
    if (autoForm.numOfBet) {
      // setRemainingBet(autoForm.numOfBet);
    }
  }, [autoForm.numOfBet]);

  useEffect(() => {
    if (socket) {
      socket.on("roundsCashedout", (response) => {
        if (response?.data) {
          setLiveCashout((prev) => ({ ...prev, data: response.data }));
        }
      });
      socket.on("winAtEvenOdd", (response) => {
        console.log("winAtEvenOdd Acknowledgment from server:", response);
        if (document.visibilityState === "visible") {
          toast.success(response?.message);
        }

        setWallet(response.balance);
        setCashedOut(response.data);
      });

      socket.on("betPlaced", (response) => {
        console.log("betPlaced Acknowledgment from server:", response);
        if (document.visibilityState === "visible") {
          toast.success(response?.message);
        }
        if (response?.InsufficientBalance) {
          setAutoForm((prev) => ({
            ...prev,
            betAmount: 0,
            cashOutAt: 0,
            crashType: "",
            numOfBet: 0,
            onWin: 0,
            onLoss: 0,
            stopProfit: 0,
            stopLoss: 0,
          }));
          setRemainingBet(0);
        }
        if (!response.status) {
          setAutoBetCompleted(true);
          setManualBetCompleted(true);

          setAllBetCompleted(true);

          // return;
        }
        if (response.status) {
          setLock(true);
          setBetStopped(false);
          setBetPlaced(response.data);
          setAutoForm((prev) => ({
            ...prev,
            betAmount: response.data.betAmount,
          }));

          if (activeTab == 1) {
            setAllBetCompleted(false);
          }


        }
        // if (activeTab == 1) {
        //   setAllBetCompleted(false);
        // } old place
        
       

        if (response?.data) {
          console.log(640)
          if (activeTab == 1) {
            setAutoForm((prev) => ({
              ...prev,
              betAmount: response.data?.betAmount,
              cashOutAt: response.data?.cashedOut,
              stopProfit: response.data?.stopProfit,
              stopLoss: response.data?.stopLoss,
              numOfBet: response.data.numOfBet,
            }));
          }

          console.log(651, response.data.numOfAutoBetOfUser)
          setRemainingBet(response.data.numOfAutoBetOfUser || 0);
          setAutoBetCompleted(false);
          setManualBetCompleted(false);

          socket.emit("betHistory", (response) => {
            console.log("betHistory Acknowledgment from server:", response);
          });

          // setWallet(response.data.wallet);
        } else if (response.numOfBetCompleted) {
          setBetStopped(true);

          setAllBetCompleted(true);
          setAutoForm((prev) => ({
            ...prev,
            betAmount: 0,
            numOfBet: 0,
            cashOutAt: 0,
            onLoss: 0,
            onWin: 0,
          }));
        }

        if (response.autoBetCompleted) {
          console.log(676, 0)
          setRemainingBet(0);
          setAutoForm((prev) => ({...prev, betAmount: 0,
            numOfBet: 0,
            cashOutAt: 0,
            onLoss: 0,
            onWin: 0,}))

          setAllBetCompleted(true);
          setAutoBetCompleted(true);
        }
      });
      socket.on("balance", (response) => {
        if (response?.data) {
          setWallet(response.data.wallet);
        }
      });
      socket.on("cashedout", (response) => {
        console.log("cashedout Acknowledgment from server:", response);
        if (document.visibilityState === "visible") {
          toast.success(response?.message);
        }

        if (activeTab == 1 && autoForm.numOfBet && !autoBetCompleted) {
          // setRemainingBet(remainingBet > 1 ? remainingBet - 1 : 0);
        }

        // setStart(false);
        setCrashFlight(null);
        if (response.data) {
          if (gameConfig?.win_sound_url) {
            playSound(gameConfig?.win_sound_url, true);
          } else {
            playSound(WinSound, true);
          }
          setCashedOut(response.data);
          setWallet(response.data.wallet);
          setAutoForm((prev) => ({
            ...prev,
            profitWin: response?.data?.profitToWin,
          }));
        }
      });
    }
  }, [socket]);

  useEffect(() => {
    if (maxBetModal.enable && maxBetModal?.maxBet) {
      setForm((prev) => ({ ...prev, betAmount: maxBetModal.maxBet }));
      setAutoForm((prev) => ({ ...prev, betAmount: maxBetModal.maxBet }));
    }
  }, [maxBetModal]);

  useEffect(() => {
    if (gameTimer) {
      socket.on("roundsBet", (response) => {
        if (response?.data) {
          setLiveBetPlace(response?.data);
        }
        socket.emit("betHistory", (response) => {
          console.log("betHistory Acknowledgment from server:", response);
        });
      });

      if (gameTimer?.time == 0) {
        // setStart(true);
        // setClear(true)

        socket.on("crashFlight", (response) => {
          setNewRoundStarted(false);
          if (gameConfig.crash_sound_url) {
            playSound(gameConfig.crash_sound_url, true);
          } else {
            playSound(CrashSound, true);
          }

          setStart(false);
          // console.log("crashFlight Acknowledgment from server:", response);
          if (autoForm?.numOfBet) {
            // setRemainingBet(remainingBet > 1 ? remainingBet - 1 : 0);
          }
          if (activeTab == 0) {
            setForm((prev) => ({
              ...prev,
              betAmount: 0,
              crashType: "",
              cashOutAt: 0,
            }));
          }
          setCrashFlight(response);
          setLock(false);

          // setStart(false);
          // setPayoutMultipier(1.0);
          // setClear(true);
          setTimeout(() => {
            // setClear(true)
            setPayoutMultipier(0);
          }, 1500);

          socket.emit("betHistory", (response) => {
            console.log("betHistory Acknowledgment from server:", response);
          });
        });
        socket.on("payoutMultiplyer", (response) => {
          setCrashFlight(null);
          setStart(true);

          if (response.num) {
            setPayoutMultipier(response.num);
          }
        });

        socket.emit("crashHistory", (response) => {
          console.log("crashHistory Acknowledgment from server:", response);
        });
      }
    }
  }, [gameTimer]);

  let persistentAudio = null;
  const audioRef = useRef(null);

  // Play sound
  const playSound = (url, run) => {
    if (audioAllowModal.allow && url) {
      if (!audioRef.current) {
        audioRef.current = new Audio(url);
        audioRef.current.loop = true;
        audioRef.current.play().catch((e) => console.error(e));
      }
      if (!run) {
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
          audioRef.current = null;
        }
      }
      audioRef.current.volume = volume / 100; // Set initial volume
    }
  };

  // Update volume runtime
  const changeVolume = (newVolume) => {
    setVolume(newVolume);
    if (audioRef.current) {
      audioRef.current.volume = newVolume / 100;
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;

    console.log(767, name, value)
    if(name == 'cashOutAt' && value) {
      setOrDisable({crash: true, cash: false})
    } else if(name == "crashType" && value !== 'Choose Crash Type') {
      setOrDisable({crash: false, cash: true})
    } else {
      setOrDisable({crash: false, cash: false})
    }

    if (name == "betAmount") {
      if (/^\d*$/.test(value)) {
        setForm((prev) => ({ ...prev, [name]: value }));
      }
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  useEffect(() => {
    // let interval = undefined;
    // if (!audioAllowModal.open) {
    //   setTimeout(() => {
    //     var n = 1.0;
    //     setPayoutMultipier(n);
    //     interval = setInterval(() => {
    //       if (n < 5) {
    //         setStart(true);
    //         n += 0.5;
    //         setPayoutMultipier(n);
    //       } else {
    //         clearInterval(interval);
    //         interval = undefined;
    //         setPayoutMultipier(0.5);
    //         // setCrashFlight(2);
    //         setStart(false)
    //         // setClear(true);
    //         setTimeout(() => {
    //           var n = 1.0;
    //           setPayoutMultipier(n);
    //           interval = setInterval(() => {
    //             if (n < 5) {
    //               setStart(true);
    //               n += 0.5;
    //               setPayoutMultipier(n);
    //             } else {
    //               clearInterval(interval);
    //         interval = undefined;
    //         setPayoutMultipier(0.5);
    //         // setCrashFlight(2);
    //         setStart(false)
    //         // setClear(true);
    //         setTimeout(() => {
    //           var n = 1.0;
    //           setPayoutMultipier(n);
    //           setStart(true);
    //           interval = setInterval(() => {
    //             if (n < 5) {
    //               n += 0.5;
    //               setPayoutMultipier(n);
    //             } else {
    //               clearInterval(interval);
    //               interval = undefined;
    //               setPayoutMultipier(0.5);
    //               // setCrashFlight(2);
    //               setStart(false)
    //               // setClear(true);
    //             }
    //           }, 100);
    //         }, 3000);
    //             }
    //           }, 100);
    //         }, 3000);
    //       }
    //     }, 100);
    //   }, 3000);
    // }
  }, [audioAllowModal]);

  const startBet = () => {
    // setStart(!start);
    // setStart(true);
    setClear(false);

    // if (start) {
    socket.emit(
      "cashout",
      {
        roundId: roundId,
        cashoutPoint: payoutMultiplier,
        socketId: socket.id,
        betAmount: form.betAmount,
      },
      (response) => {
        console.log("cashout Acknowledgment from server:", response);
      }
    );

    socket.emit("crashHistory", (response) => {
      console.log("crashHistory Acknowledgment from server:", response);
    });
    // }
  };

  const placeBet = () => {
    if (gameTimer?.time > gameConfig.betLock) {
      let payload;
      if (activeTab == 0) {
        payload = {
          roundId: roundId,
          betAmount: form.betAmount,
          crashType: form?.crashType,
          betType: "manualBet",
          cashedOut: Number(form?.cashOutAt),
          admin_id: gameConfig?.admin_id,
          socketId: socket.id,
          engine_id: gameConfig?.engine_id,
        };
        if (
          form.betAmount < gameConfig.min_betamount ||
          form.betAmount > gameConfig.max_betamount
        ) {
          setManualBetCompleted(true);
          toast.warn(
            `Bet amount should be more than (${gameConfig.min_betamount}) and less than (${gameConfig.max_betamount})`
          );
          return;
        } else if (
          form.cashOutAt > 0 &&
          form.cashOutAt < gameConfig.min_cashout_value
        ) {
          setManualBetCompleted(true);
          toast.warn(
            `Minimum cashout value should be ${gameConfig.min_cashout_value}`
          );
          return;
        } else if (form.betAmount) {
          setAutoBetCompleted(false);
          setManualBetCompleted(false);
          console.log(876);
          socket.emit("placeBet", payload, (response) => {
            console.log(
              "placeBet Acknowledgment from server:",
              roundId,
              response
            );
          });
        } else {
          toast.warn("Please fill required data to place the bet.");
        }
      } else {
        payload = {
          roundId: roundId,
          betAmount: autoForm.betAmount,
          crashType: autoForm?.crashType,
          betType: "autoBet",
          betAmount: autoForm.betAmount,
          crashType: autoForm?.crashType,
          numOfBet: autoForm.numOfBet,
          stopProfit: autoForm.stopProfit,
          stopLoss: autoForm.stopLoss,
          cashedOut: Number(autoForm?.cashOutAt),
          admin_id: gameConfig?.admin_id,
          socketId: socket.id,
          onWin: autoForm.onWin,
          onLoss: autoForm.onLoss,
          engine_id: gameConfig?.engine_id,
        };
        if (
          autoForm.betAmount < gameConfig.min_betamount ||
          autoForm.betAmount > gameConfig.max_betamount
        ) {
          setAutoBetCompleted(true);
          toast.warn(
            `Bet amount should be more than (${gameConfig.min_betamount}) and less than (${gameConfig.max_betamount})`
          );
          return;
        } else if (autoForm.numOfBet && autoForm.numOfBet < 2) {
          setAutoBetCompleted(true);
          toast.warn("Number of bet should be more than (1) in Auto bet.");
          return;
        }

        if (!autoForm.cashOutAt) {
          setAutoBetCompleted(true);
          toast.warn("Please fill cashOut At field.");
          return;
        }

        if (autoForm.betAmount && autoForm.cashOutAt) {
          setAutoBetCompleted(false);
          setManualBetCompleted(false);

          setAllBetCompleted(false);
          setRemainingBet(autoForm.numOfBet);
          socket.emit("placeBet", payload, (response) => {
            console.log(
              "placeBet Acknowledgment from server:",
              roundId,
              response
            );
          });
        } else {
          toast.warn("Please add required data to place a bet.");
          return;
        }
      }
    } else {
    }
  };

  const handlePostClick = (name, value, type) => {
    if (type == "up") {
      setForm((prev) => ({ ...prev, [name]: value + 1 }));
    } else if (type == "down") {
      if (value > 0) {
        setForm((prev) => ({ ...prev, [name]: value - 1 }));
      }
    } else {
      if (type * form.betAmount >= gameConfig?.max_betamount) {
        setForm((prev) => ({
          ...prev,
          [name]: Number(gameConfig?.max_betamount),
        }));
      } else {
        setForm((prev) => ({ ...prev, [name]: type * form.betAmount }));
      }
    }
  };

  const stop = () => {
    socket.emit(
      "stopAutoBet",
      {
        roomId: tableJoined.roomId,
        roundId: tableJoined.roundId,
        socketId: socket.id,
      },
      (response) => {
        if (document.visibilityState === "visible") {
          toast.success(response.message);
        }
        setRemainingBet(0);
        setAutoForm((prev) => ({
          ...prev,
          betAmount: 0,
          numOfBet: 0,
          cashOutAt: 0,
          onLoss: 0,
          onWin: 0,
        }));

        setBetStopped(true);

        setAutoBetCompleted(true);

        setAllBetCompleted(true);
        console.log("stopAutoBet Acknowledgment from server:", response);
      }
    );
  };

  const joinLiveChat = (message) => {
    if (gameConfig) {
      socket.emit(
        "sendChat",
        {
          adminId: gameConfig?.admin_id,
          message: message || "",
        },
        (response) => {
          console.log(618, response);
        }
      );
    } else {
      toast.warn("user not joined");
    }
  };

  return (
    <div>
      <React.Fragment>
        <AudioModal open={audioAllowModal} setOpen={setAudioAllowModal} />

        {/* <WebAudioPlayer inputVolume={volume/100} play={audioAllowModal.allow} url={'https://rgs-backend.s3.amazonaws.com/theme-assets/background_sound_url-1742984054695-177488946.mp3'} /> */}
        <BetTypeModal open={betTypeModal} setOpen={setBetTypeModal} />
        {gameConfig?.live_chat && (
          <button
            className="text-white chat-icon"
            onClick={() => {
              joinLiveChat("");
              setOpenChat(!openChat);
            }}
          >
            💬
          </button>
        )}

        {openChat && <LiveChat data={messages} handleChat={joinLiveChat} />}
      </React.Fragment>
      {/* <div>
        <h2>{isOnline ? "Online ✅" : "Offline ❌"}</h2>
      
        <button
          type="button"
          className=""
          onClick={() => {
            
            if(socketConn.connected) {
              socketConn.disconnect();
              setIsOnline(false)
            } else {
              socketConn.connect();
              setIsOnline(true)
            }
          }}
          style={{ backgroundColor: "#F8B731" }}
        >
          Disconnect
         
        </button>
      </div> */}
      {gameConfig && (
        <Draggable>
          <div className="absolute z-50  rounded bg-blue-500 text-white items-center justify-center rounded-lg shadow-lg cursor-move">
            <LiveStats
              isOpen={settingStartupPopover.startup}
              setOpen={setSettingStartupPopover}
            />
          </div>
        </Draggable>
      )}

      {/* grid grid-cols-2 sm:grid-cols-2 md:grid-cols-12 lg:grid-cols-12 */}
      <div
        className="  grid grid-cols-2 sm:grid-cols-2 md:grid-cols-12 lg:grid-cols-12 "
        style={{ minHeight: window.innerHeight - 100 }}
      >
        {/* xs:order-1  sm:order-1 md:order-2 lg:order-2 p-2  flex flex-col col-span-6 sm:col-span-6 md:col-span-6 */}
        <div
          className="xs:order-1 sm:order-1 md:order-2 lg:order-2 p-2 flex flex-col col-span-6 sm:col-span-6 md:col-span-9"
          style={{
            backgroundColor: "rgb(15, 33, 46)",
            borderRadius: "0px 20px 20px 0px",
            display: "grid",
          }}
        >
          <div className=" justify-content-between">
            <div className="d-flex flex-wrap justify-between">
              <div className="px-2 py-1 m-1 bg-gray-300 rounded-lg cursor-pointer">
                <i className="bi bi-people-fill"></i>{" "}
                {gameTimer?.currentPlayers}
              </div>

              <div className="d-flex flex-wrap">
                {cashedOutHistory?.map((item, index) => (
                  <div
                    key={index}
                    className={`rounded-full font-semibold text-xs p-2 m-1 ${
                      item.positiveImpact
                        ? " crashout-box-green "
                        : " crashout-box-gray "
                    }`}
                  >
                    {item.bet.flyAway} X
                  </div>
                ))}
              </div>

              <div>
                {gameConfig?.game_history && (
                  <div
                    className="px-2 py-1 m-1 bg-gray-300 rounded-lg cursor-pointer"
                    onClick={(e) => {
                      setHistoryOpen(!historyOpen);
                    }}
                  >
                    <i className="bi bi-clock-history"></i>
                  </div>
                )}
              </div>
            </div>
            <div className="d-flex justify-content-around">
              <p className="text-white">Wallet: {wallet?.toFixed(2)}</p>
            </div>
          </div>
          <div id="id" className="position-relative">
            {makeItJoinAgain && (
              <div
                className="position-absolute d-flex flex-column align-items-center justify-content-center w-100 h-100"
                style={{ backgroundColor: "rgba(0, 0, 0, 0.7)", zIndex: 100, top: 0, left: 0 }}
              >
                <h3 className="text-white text-center fw-bold">Waiting for Next Round...</h3>
              </div>
            )}
            <div className="live-div-main d-flex flex-column align-items-end">
              {liveCashout?.data
                ?.reverse()
                ?.slice(0, 4)
                .map((item, index) => (
                  <div
                    key={index}
                    className={`d-flex rounded-s-full rounded-e-full 
              outline-white live-div-${index} m-1 px-2 py-1 w-fit`}
                  >
                    <span className="text-white text-sm align-self-center font-semibold">
                      {item.username}
                    </span>
                    <img src={Doller} className="coin-img m-1" alt="icon" />
                    <spna className="f-green text-sm align-self-center font-semibold">
                      {item.winAmount?.toFixed(2)}
                    </spna>
                  </div>
                ))}
            </div>

            {document.getElementById("id")?.offsetWidth &&
              document.getElementById("id")?.offsetHeight &&
              gameConfig && (
                <CasinoCrashGame
                  start={start}
                  clear={clear}
                  socketMultipler={payoutMultiplier}
                  crashFlight={crashFlight}
                  cashedOut={cashedOut}
                  time={gameTimer?.time || 0}
                  aviatorImg={gameConfig?.aviator_image || ""}
                  maxTimer={gameConfig?.countDown}
                />
              )}
          </div>
        </div>

        {/* https://rgs-backend.s3.amazonaws.com/theme-assets/aviator_image-1747820943191-223482281.png */}

        {/* xs:order-2 sm:order-2 md:order-1 lg:order-1  flex flex-col col-span-6 sm:col-span-6 md:col-span-3 */}
        <div
          className="rounded-tl-none-xs rounded-tl-none-sm xs:order-2 sm:order-2 md:order-1 lg:order-1 flex flex-col col-span-6 sm:col-span-6 md:col-span-3"
          style={{
            backgroundColor: "rgb(33 55 67)",
            borderRadius: "20px 0px 0px 20px",
          }} // 181D29
        >
          <div className=" m-3">
            <div
              className="justify-content-center text-center p-1 rounded w-auto "
              style={{ backgroundColor: "rgb(15 33 46)" }}
            >
              {tabs.map((tab, index) => (
                <button
                  key={index}
                  onClick={() => setActiveTab(index)}
                  className={`  text-sm sm:text-sm md:text-sm lg:text-base py-1 py-sm-1 py-md-1 py-lg-1 px-1 px-sm-2 px-md-3 px-lg-3 w-1/2 rounded flex-1 font-semibold text-center`}
                  style={
                    activeTab == index
                      ? { backgroundColor: "rgb(47 69 83)", color: "white" }
                      : { backgroundColor: "rgb(15 33 46)", color: "gray" }
                  }
                >
                  {tab}
                </button>
              ))}
            </div>
            {activeTab == 0 && (
              <div>
                <div
                  className={
                    gameTimer?.time < 1
                      ? "opacity-50 disabled:cursor-not-allowed"
                      : ""
                  }
                >
                  <InputPrePostFixComponent
                    name={"betAmount"}
                    label={"Bet amount"}
                    type={"number"}
                    placeholder={"Enter Bet Amount"}
                    value={form.betAmount}
                    handleChange={handleChange}
                    required
                    postOne={"1/2"}
                    postTwo={"2"}
                    handlePostClick={handlePostClick}
                    icon={true}
                    postType={"number"}
                    disabled={!manualBetCompleted}
                  />
                  <div className={orDisable.cash ? "cursor-none" : " "}>
                  <InputPrePostFixComponent
                    name={"cashOutAt"}
                    label={"Cashout At"}
                    type={"number"}
                    placeholder={"Enter Cashout At"}
                    value={form.cashOutAt}
                    handleChange={handleChange}
                    required
                    handlePostClick={handlePostClick}
                    icon={false}
                    postType={"arrow"}
                    disabled={!manualBetCompleted}
                  />
                  </div>
                 
                  <p className="text-white test-sm m-auto text-center pb-0">OR</p>

                  <div className={orDisable.crash ? "cursor-none" : " "}>
                  <SelectComponent
                    name={"crashType"}
                    label={"Crash Type"}
                    options={options}
                    required
                    value={form.crashType}
                    disabled={!manualBetCompleted}
                    handleChange={handleChange}
                    style={{ color: "#a7a7a7" }}
                  />
                  </div>
                 
                </div>
                .
                <div className="d-block me-3">
                  <button
                    type="button"
                    className=" disabled:cursor-not-allowed disabled:opacity-50 disabled:cursor-not-allowed w-full text-center text-black
                   shadow-lg 
                   font-medium rounded-lg text-sm px-2 px-sm-2 px-md-4 
                   px-lg-4 py-1 py-sm-1 py-md-2 py-lg-2 text-center mx-2 my-1"
                    onClick={() => {
                      startBet(payoutMultiplier);
                    }}
                    style={{ backgroundColor: "#F8B731" }}
                    disabled={betCashoutDisable}
                  >
                    Cashout
                  </button>
                  <button
                    type="button"
                    className="disabled:cursor-not-allowed disabled:opacity-50 w-full text-center text-black mt-2
                    shadow-lg 
                    font-medium rounded-lg text-md px-3 px-sm-2 px-md-4 pt-2
                    px-lg-4 py-1 py-sm-1 py-md-2 py-lg-2 text-center mx-2 my-1"
                    onClick={() => {
                      placeBet();
                    }}
                    style={{ backgroundColor: "#068fa9" }}
                    disabled={!manualBetCompleted} //lock
                  >
                    Bet
                  </button>
                </div>
                {liveCashout?.data.length > 0 && (
                  <LiveHistory title={"Cashout At"} data={liveCashout.data} />
                )}
              </div>
            )}
            {activeTab == 1 && (
              <Fragment>
                <div
                  className="justify-content-center text-center p-1 rounded w-auto mt-1 "
                  style={{ backgroundColor: "rgb(15 33 46)" }}
                >
                  {subTabs.map((tab, index) => (
                    <button
                      key={index}
                      onClick={() => setActiveSubTab(index)}
                      className={` text-sm sm:text-sm md:text-sm lg:text-base  py-1 py-sm-1 py-md-1 py-lg-1 px-1 px-sm-2 px-md-3 px-lg-3 w-1/2 rounded flex-1 text-center`}
                      style={
                        activeSubTab == index
                          ? { backgroundColor: "rgb(47 69 83)", color: "white" }
                          : { backgroundColor: "rgb(15 33 46)", color: "gray" }
                      }
                    >
                      {tab}
                    </button>
                  ))}
                </div>

                {activeSubTab == 0 && (
                  <Fragment>
                    <AutobetControls
                      autoForm={autoForm}
                      setAutoForm={setAutoForm}
                      maxBetAmt={gameConfig?.max_betamount}
                      disabled={!autoBetCompleted}
                      remainingBet={remainingBet}
                    />
                    <div className="d-block me-3">
                      <button
                        type="button"
                        className="disabled:cursor-not-allowed disabled:opacity-50 w-full text-center text-black
                   shadow-lg 
                   font-medium rounded-lg text-sm px-2 px-sm-2 px-md-4 
                   px-lg-4 py-1 py-sm-1 py-md-2 py-lg-2 text-center mx-2 my-1"
                        onClick={() => {
                          placeBet();
                        }}
                        style={{ backgroundColor: "#068fa9" }}
                        disabled={!autoBetCompleted || !allBetCompleted} // lock
                      >
                        Auto Bet
                      </button>
                      <button
                        type="button"
                        className="disabled:cursor-not-allowed disabled:opacity-50 w-full text-center text-black
                   shadow-lg 
                   font-medium rounded-lg text-sm px-2 px-sm-2 px-md-4 
                   px-lg-4 py-1 py-sm-1 py-md-2 py-lg-2 text-center mx-2 my-1"
                        onClick={() => {
                          stop();
                        }}
                        disabled={autoBetCompleted}
                        style={{ backgroundColor: "#F8B731" }}
                      >
                        Stop Autobet
                      </button>
                    </div>
                  </Fragment>
                )}

                {activeSubTab == 1 && (
                  <Fragment>
                    <LiveHistory title={"Bets"} data={liveBetPlace} />
                  </Fragment>
                )}
              </Fragment>
            )}
          </div>
        </div>
      </div>

      {betHistory.length > 0 && (
        <HistoryModal
          isOpen={historyOpen}
          setOpen={setHistoryOpen}
          data={betHistory}
        />
      )}

      <div className=" mt-1">
        <div
          className="xs:order-1  sm:order-1 md:order-2 lg:order-2 p-2 flex flex-col col-span-6 sm:col-span-6 md:col-span-6 gap-2 "
          style={{
            backgroundColor: "rgb(15 33 46)",
            borderRadius: "10px",
          }}
        >
          <div className="d-flex">
            <div className="relative inline-block">
              <img
                src={Setting}
                className="coin-img m-1 cursor-pointer"
                onClick={() => {
                  setSettingStartupPopover((prev) => ({
                    ...prev,
                    setting: !settingStartupPopover?.setting,
                  }));
                }}
                alt="setting"
              />
              {settingStartupPopover?.setting && (
                <div className="absolute left-1/2 bottom-full mt-2 w-60 bg-white shadow-lg border rounded p-3 -translate-x-1">
                  <div>
                    <ul>
                      <li className="d-flex">
                        <img
                          src={Volume}
                          className="coin-img m-1 me-2"
                          alt="volume"
                        />
                        <input
                          type="range"
                          min="1"
                          max="100"
                          value={volume}
                          onChange={(e) => {
                            changeVolume(e.target.value);
                            // console.log(e.target.value)
                            // setVolume(e.target.value);
                          }}
                        />
                      </li>
                      <li
                        className="d-flex cursor-pointer"
                        onClick={() => {
                          // {open: false, maxBet: 0, enable: false}

                          setMaxBetModal((prev) => ({
                            ...prev,
                            open: !maxBetModal.open,
                          }));
                        }}
                      >
                        {" "}
                        <img
                          src={Maxbet}
                          className="coin-img m-1 me-2"
                          alt="max-bet"
                        />
                        Max Bet
                      </li>
                      <li
                        className="d-flex cursor-pointer"
                        onClick={() => {
                          setLiveCashout((prev) => ({
                            ...prev,
                            show: !liveCashout.show,
                          }));
                        }}
                      >
                        <img
                          src={Users}
                          className="coin-img m-1 me-2"
                          alt="user"
                        />
                        Show player result
                      </li>
                      <li
                        className="d-flex cursor-pointer"
                        onClick={() => {
                          setGameInfoModal(!gameInfoModal);
                        }}
                      >
                        <img
                          src={Info}
                          className="coin-img m-1 cursor-pointer me-2"
                          alt="info"
                        />
                        Game Info
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>

            <img
              src={Startup}
              className="coin-img m-1 cursor-pointer"
              onClick={() => {
                setSettingStartupPopover((prev) => ({
                  ...prev,
                  startup: !settingStartupPopover.startup,
                }));
              }}
              alt="startup"
            />
          </div>
        </div>
      </div>

      {maxBetModal.open && (
        <MaxBetModal
          isOpen={maxBetModal.open}
          setOpen={setMaxBetModal}
          maxBet={maxBetModal.maxBet}
        />
      )}
      {gameInfoModal && (
        <GameInfoModal isOpen={gameInfoModal} setOpen={setGameInfoModal} />
      )}
      {/* {liveBetPlace.length > 0 && (
        <LiveHistory title={"Bets"} data={liveBetPlace} />
      )} */}
    </div>
  );
};
